import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthProvider } from "../context/AuthContext";
import Navbar from "../Components/Navbar";
import HalfHero from "../Images/main.jpg";
import { Bell } from "lucide-react";
import sideImg from "../Images/sideImg.png";
import EnquiryForm from "./EnquiryForm";

const About = () => {
  const navigate = useNavigate();
  const { user } = useContext(AuthProvider) || {};

  const handleExploreBusinesses = () => {
    navigate("/services");
  };
  const handleExploreenquiryform = () => {
    navigate("/enquiryform");
  };

  const handleRegisterCompany = () => {
    if (user && user.role === "provider") {
      navigate("/provider/dashboard");
    } else {
      navigate("/signup");
    }
  };

  return (
    <div className="min-h-screen w-full flex flex-col items-center poppins-regular">
      {/* Navbar and Hero Section (like Blogs page) */}
      <section className="relative w-full h-1/2 overflow-hidden">
        {/* Background Image (with blur) */}
        <img
          src={HalfHero}
          alt="Hero Background"
          className="absolute inset-0 w-full h-full object-cover z-[-10] blur-sm"
        />
        {/* Navbar */}
        <Navbar />
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/70 z-[-5]" />
      </section>
      {/* Main About Content */}
      <div className="w-full flex flex-col items-center py-8 px-2 sm:px-6 md:px-12 lg:px-32">
        {/* Hero Section */}
        <section className="w-10/12 text-center mb-10">
          <h1 className="text-2xl sm:text-3xl md:text-5xl font-bold bg-gradient-to-r from-orange-500 via-white to-green-500 rounded-lg sm:rounded-xl md:rounded-2xl py-1 mb-2">
            OIM – Online Indian Market
          </h1>
          <h2 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-700 mb-4">
            Global B2B & B2C Business Directory
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 mb-4 leading-relaxed">
            “Connecting Businesses, Creating Opportunities.”
          </p>
          <p className="text-sm sm:text-base md:text-xl text-gray-500 mb-4 leading-relaxed">
            Your Gateway to Global Trade & Business to Customer Networking.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-4">
            <button
              className="bg-orange-500 text-white px-6 py-2 rounded-lg font-semibold shadow hover:bg-orange-600 transition"
              onClick={handleExploreBusinesses}
            >
              Explore Businesses
            </button>
            <button
              className="bg-gray-200 text-black px-6 py-2 rounded-lg font-semibold shadow hover:bg-gray-300 transition"
              onClick={handleRegisterCompany}
            >
              Register Your Company
            </button>
            <button
              className="bg-green-600 text-white px-6 py-2 rounded-lg
              font-semibold shadow hover:bg-green-700 transition"
              onClick={handleExploreenquiryform}
            >
              Register As Partner
            </button>
          </div>
        </section>

        {/* English About Section */}
        <section className="w-10/12 bg-white rounded-xl shadow p-5 sm:p-6 md:p-8 mb-10">
          <h3 className="text-lg sm:text-xl md:text-2xl font-semibold md:font-bold text-gray-800 mb-4">
            About Online Indian Market (OIM)
          </h3>
          <p className="text-gray-700 text-sm sm:text-base md:text-lg mb-4 leading-relaxed ">
            OIM (Online Indian Market) is a worldwide business directory and
            B2B–B2B & B2C (Business to Customer) networking hub empowering
            businesses with digital branding, partnerships, and international
            trade opportunities.
          </p>
          <p className="text-gray-700 text-sm sm:text-base md:text-lg mb-4 leading-relaxed">
            OIM is designed to connect businesses, industries, and markets
            across the globe. By bringing together vendors, manufacturers,
            distributors, and service providers on one platform, OIM creates a
            dynamic ecosystem for trade, collaboration, and growth.
          </p>
          <p className="text-gray-700 text-sm sm:text-base md:text-lg mb-4 italic leading-relaxed">
            “From Local Roots to Global Markets.”
          </p>
          <p className="text-gray-700 text-sm sm:text-base md:text-lg mb-4 leading-relaxed">
            At OIM, we empower organizations of every scale – from emerging
            startups to multinational corporations – to showcase their profiles,
            products, and services before a global audience. We are not just a
            directory; we are a digital marketplace that drives visibility,
            builds partnerships, and opens doors to new opportunities across
            borders.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
            <div>
              <h4 className="text-lg font-semibold text-orange-600 mb-2">
                Our Vision
              </h4>
              <p className="text-gray-700 text-sm sm:text-base md:text-lg leading-relaxed">
                To establish a world-class digital platform on which businesses
                of all sizes – from small startups to multinational
                conglomerates – are able to present their products, services,
                and innovations before a global audience.
              </p>
            </div>
            <div>
              <h4 className="text-lg font-semibold text-green-700 mb-2">
                Our Mission
              </h4>
              <p className="text-gray-700 text-sm sm:text-base md:text-lg leading-relaxed">
                To empower businesses by providing a reliable, transparent, and
                technology-powered marketplace that enables growth, cooperation,
                and global trade.
              </p>
            </div>
          </div>
        </section>

        {/* What We Do Section */}
        <section className="w-10/12 bg-gray-50 rounded-xl shadow p-6 mb-6 md:mb-10">
          <h3 className="text-xl sm:text-xl md:text-2xl font-semibold md:font-bold text-center md:text-left text-gray-800 mb-4 md:mb-6">
            What We Do
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 md:gap-6">
            <div className="bg-white rounded-lg shadow p-4 flex flex-col items-center mb-4">
              <span className="text-3xl mb-2">🌍</span>
              <h5 className="font-semibold text-lg mb-2">
                Global Directory Listings
              </h5>
              <p className="text-gray-600 text-center leading-relaxed">
                Showcase your company worldwide
              </p>
            </div>
            <div className="bg-white rounded-lg shadow p-4 flex flex-col items-center mb-4">
              <span className="text-3xl mb-2">🤝</span>
              <h5 className="font-semibold text-lg mb-2">
                B2B & B2C Networking
              </h5>
              <p className="text-gray-600 text-center leading-relaxed">
                Connect with vendors, distributors & partners
              </p>
            </div>
            <div className="bg-white rounded-lg shadow p-4 flex flex-col items-center mb-4">
              <span className="text-3xl mb-2">🌐</span>
              <h5 className="font-semibold text-lg mb-2">Market Expansion</h5>
              <p className="text-gray-600 text-center leading-relaxed">
                Access new countries & industries
              </p>
            </div>
            <div className="bg-white rounded-lg shadow p-4 flex flex-col items-center mb-4">
              <span className="text-3xl mb-2">🚀</span>
              <h5 className="font-semibold text-lg mb-2">Digital Branding</h5>
              <p className="text-gray-600 text-center leading-relaxed">
                Increase visibility & global reach
              </p>
            </div>
          </div>
        </section>

        {/* Why Choose OIM Section */}
        <section className="w-10/12 bg-white rounded-xl shadow p-6 mb-10">
          <h3 className="text-xl sm:text-2xl md:text-2xl font-semibold md:font-bold text-gray-800 mb-4 md:mb-6">
            Why Choose OIM?
          </h3>
          <ul className="list-disc list-inside text-gray-700 text-sm sm:text-base md:text-lg space-y-3 leading-relaxed mb-4">
            <li>
              <b>Global Reach:</b> Bringing Indian and global businesses onto
              one reliable platform.
            </li>
            <li>
              <b>B2B & B2C Business Expansion:</b> Enabling partnerships,
              alliances, and Business to Customer expansion.
            </li>
            <li>
              <b>Trusted Platform:</b> Protected, secure, and professional
              business ecosystem.
            </li>
            <li>
              <b>Innovation & Technology:</b> Intelligent tools and digital
              marketing support.
            </li>
          </ul>
        </section>

        {/* Hindi About Section */}
        <section className="w-10/12 bg-gray-50 rounded-xl shadow p-6 mb-10">
          <h3 className="text-xl sm:text-xl md:text-2xl font-semibold md:font-bold text-orange-700 mb-4 md:mb-6">
            OIM – ऑनलाइन इंडियन मार्केट
          </h3>
          <p className="text-gray-700 text-sm sm:text-base md:text-lg mb-4 leading-relaxed">
            OIM (Online Indian Market) एक वैश्विक बिज़नेस डायरेक्टरी और B2B–B2B
            & B2C (Business to Customer) नेटवर्किंग प्लेटफॉर्म है, जो कंपनियों
            को जोड़कर वैश्विक व्यापार के अवसर बढ़ाता है।
          </p>
          <p className="text-gray-700 text-sm sm:text-base md:text-lg mb-4 leading-relaxed">
            हमारा विज़न है – "एक ऐसा डिजिटल मार्केटप्लेस तैयार करना जो स्थानीय
            से वैश्विक स्तर तक व्यापार को सरल, पारदर्शी और प्रभावी बनाए।"
          </p>
          <ul className="list-disc list-inside text-gray-700 text-sm sm:text-base md:text-lg mb-4 leading-relaxed space-y-2">
            <li>
              प्रोफ़ाइल, प्रोडक्ट्स और सेवाएँ ग्लोबल ऑडियंस के सामने पेश कर
              सकें।
            </li>
            <li>
              Business to Customer (B2B & B2C) नेटवर्किंग के माध्यम से नए
              पार्टनरशिप और कोलैबोरेशन पैदा कर सकें।
            </li>
            <li>नए मार्केट्स और बिज़नेस अवसरों तक पहुँच सकें।</li>
            <li>
              डिजिटल डायरेक्टरी लिस्टिंग के माध्यम से अंतरराष्ट्रीय स्तर पर अपनी
              पहचान स्थापित कर सकें।
            </li>
          </ul>
          <h4 className="text-lg font-semibold text-green-700 mb-2 mt-4">
            OIM क्यों चुनें?
          </h4>
          <ul className="list-disc list-inside text-gray-700 text-sm sm:text-base md:text-lg  space-y-2 leading-relaxed mb-2">
            <li>
              🌍 ग्लोबल रीच: भारत से लेकर दुनिया के हर कोने तक कंपनियों को
              जोड़ना।
            </li>
            <li>
              🤝 B2B & B2C बिज़नेस एक्सपैंशन: सप्लायर्स, मैन्युफैक्चरर्स,
              डिस्ट्रीब्यूटर्स और सर्विस प्रोवाइडर्स को एक साथ लाना।
            </li>
            <li>
              🔒 ट्रस्टेड प्लेटफॉर्म: सुरक्षित और प्रोफेशनल नेटवर्किंग वातावरण।
            </li>
            <li>
              ⚙️ इनोवेशन & टेक्नोलॉजी: स्मार्ट टूल्स और डिजिटल मार्केटिंग
              सपोर्ट।
            </li>
          </ul>
        </section>
      </div>
      <section className="w-full h-full flex flex-col justify-center items-center py-5 sm:py-16 sm:px-10 bg-gray-200 gap-5 sm:gap-10">
        <h1 className="poppins-semibold text-xl tracking-wider sm:text-2xl md:text-3xl flex flex-col justify-center items-center uppercase text-center">
          How it Works?
          <span className="w-4/5 outline outline-1 mt-2 outline-neutral-500"></span>
        </h1>

        <div className="flex flex-col md:flex-row justify-center items-center w-full md:w-10/12 gap-5 sm:gap-8">
          {/* Steps Container */}
          <div className="flex flex-col justify-center items-center gap-5 sm:gap-8 w-full md:w-2/3">
            {/* STEP 1 */}
            <div className="flex flex-col sm:flex-row gap-6 sm:gap-10 justify-center items-center sm:items-start w-full text-center sm:text-left">
              {/* ICON HIDDEN ON MOBILE */}
              <div className="hidden sm:flex bg-purple-900 text-white rounded-full p-3 sm:p-4 justify-center items-center">
                <Bell className="h-6 w-6 sm:h-8 sm:w-8" />
              </div>

              <div className="flex flex-col items-center sm:items-start">
                <strong className="poppins-semibold tracking-wider text-lg sm:text-xl text-neutral-800">
                  Get Discovered by Local Customers
                </strong>

                {/* MOBILE CONTENT */}
                <p className="text-sm w-11/12 poppins-regular text-neutral-700 sm:hidden">
                  By listing your services, you instantly become visible to
                  people searching for providers in your area. Whether you’re a
                  plumber, tutor, shop, or consultant — customers can find you
                  easily.
                </p>

                {/* DESKTOP CONTENT */}
                <p className="hidden sm:block text-md w-11/12 poppins-regular text-neutral-700">
                  By listing your services, you instantly become visible to
                  people searching for providers in your area. Whether you’re a
                  plumber, tutor, shop, or consultant — customers can find you
                  easily.
                </p>
              </div>
            </div>

            {/* STEP 2 */}
            <div className="flex flex-col sm:flex-row gap-6 sm:gap-10 justify-center items-center sm:items-start w-full text-center sm:text-left">
              <div className="hidden sm:flex bg-purple-900 text-white rounded-full p-3 sm:p-4 justify-center items-center">
                <Bell className="h-6 w-6 sm:h-8 sm:w-8" />
              </div>

              <div className="flex flex-col items-center sm:items-start">
                <strong className="poppins-semibold tracking-wider text-lg sm:text-xl text-neutral-800">
                  Build Trust with Verified Profiles
                </strong>

                {/* MOBILE */}
                <p className="text-sm w-11/12 poppins-regular text-neutral-700 sm:hidden">
                  Your profile includes business details, documents, and reviews
                  to build trust.
                </p>

                {/* DESKTOP */}
                <p className="hidden sm:block text-md w-11/12 poppins-regular text-neutral-700">
                  Your profile includes business details, documents (GST, PAN,
                  etc.), and reviews, which help build credibility. A complete
                  profile means customers are more likely to choose you over
                  competitors.
                </p>
              </div>
            </div>

            {/* STEP 3 */}
            <div className="flex flex-col sm:flex-row gap-6 sm:gap-10 justify-center items-center sm:items-start w-full text-center sm:text-left">
              <div className="hidden sm:flex bg-purple-900 text-white rounded-full p-3 sm:p-4 justify-center items-center">
                <Bell className="h-6 w-6 sm:h-8 sm:w-8" />
              </div>

              <div className="flex flex-col items-center sm:items-start">
                <strong className="poppins-semibold tracking-wider text-lg sm:text-xl text-neutral-800">
                  Showcase Your Services & Offers
                </strong>

                {/* MOBILE */}
                <p className="text-sm w-11/12 poppins-regular text-neutral-700 sm:hidden">
                  Show prices, images & services like a mini online shop.
                </p>

                {/* DESKTOP */}
                <p className="hidden sm:block text-md w-11/12 poppins-regular text-neutral-700">
                  You can highlight multiple products/services, prices, images,
                  and descriptions. This acts like a mini online shop for your
                  business, attracting customers already looking for what you
                  offer.
                </p>
              </div>
            </div>

            {/* STEP 4 */}
            <div className="flex flex-col sm:flex-row gap-6 sm:gap-10 justify-center items-center sm:items-start w-full text-center sm:text-left">
              <div className="hidden sm:flex bg-purple-900 text-white rounded-full p-3 sm:p-4 justify-center items-center">
                <Bell className="h-6 w-6 sm:h-8 sm:w-8" />
              </div>

              <div className="flex flex-col items-center sm:items-start">
                <strong className="poppins-semibold tracking-wider text-lg sm:text-xl text-neutral-800">
                  Grow with More Leads & Conversions
                </strong>

                {/* MOBILE */}
                <p className="text-sm w-11/12 poppins-regular text-neutral-700 sm:hidden">
                  More visibility = more inquiries & conversions.
                </p>

                {/* DESKTOP */}
                <p className="hidden sm:block text-md w-11/12 poppins-regular text-neutral-700">
                  The directory brings continuous traffic from people actively
                  searching. More visibility → more inquiries → more conversions
                  → steady growth for your business.
                </p>
              </div>
            </div>
          </div>

          {/* Image */}
          <img
            src={sideImg}
            className="h-auto w-4/5 sm:w-2/3 md:w-2/5 object-contain"
            alt="TestImage"
          />
        </div>

        <strong className="poppins-semibold text-sm md:text-xl text-center text-black tracking-wider uppercase ">
          List → Get Found → Build Trust → Get More Customers → Grow.
        </strong>
      </section>
    </div>
  );
};

export default About;
